// sort-imports-ignore
// this has to be the first import
import i18n from "./i18n";
import { apiClient } from "shared/repositories/clients";
import { createApp, Plugin } from "vue";
import Toast from "vue-toastification";
import App from "./App.vue";
import router from "./router";
import logger from "shared/services/logger";
import PublicTokenRepository from "shared/repositories/PublicTokenRepository";
import "@/styles/app.css";

const app = createApp(App);

logger.init(app, router);

apiClient.defaults.baseURL = process.env.VUE_APP_API_BASE;

const token = new URLSearchParams(window.location.search).get("token") || "";
if (token) {
  const auth = `Bearer ${PublicTokenRepository.PublicTokenBearerAuthPrefix}${token}`;
  apiClient.defaults.headers.common["Authorization"] = auth;
}

app
  .use(i18n as Plugin)
  .use(router)
  .use(Toast)
  .mount("#app");
